import useFetch from '../../../hooks/useFetch';
import { WarehouseQuoteHistoryDataForm, WarehouseQuoteHistoryFilters } from '../../models/WareHouseQuoteHistory';
import { EndPoints } from '../EndPoints';
import { ServiceEvents } from '../shared/interfaces';
import { useState } from 'react';

const useWarehouseHistoryService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingUpdateWarehouseHistory, setFetchingUpdateWarehouseHistory] = useState(false);
    const [fetchingGetWarehouseQuoteHistory, setFetchingGetWarehouseQuoteHistory] = useState(false);
    const [fetchingGetWarehouseQuoteHistorys, setFetchingGetWarehouseQuoteHistorys] = useState(false);
    const [fetchingStoreWarehouseQuoteHistory, setFetchingStoreWarehouseQuoteHistory] = useState(false);
    const [fetchingEditWarehouseQuoteHistory, setFetchingEditWarehouseQuoteHistory] = useState(false);
    const [fetchingCreateWarehouseQuoteHistory, setFetchingCreateWarehouseQuoteHistory] = useState(false);
    const [fetchingShowWarehouseQuoteHistory, setFetchingShowWarehouseQuoteHistory] = useState(false);
    const getWarehouseQuoteHistory = (quoteId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.GET_WAREHOUSE_STORAGE.replace(':quote_id', quoteId.toString()),
            setFetching: setFetchingGetWarehouseQuoteHistory
        });
    };

    const getAllWarehouseQuoteHistorysByQuote = (
        quoteId: number,
        storageFilters: WarehouseQuoteHistoryFilters,
        events: ServiceEvents = {}
    ) => {
        const queryString = Object.entries(storageFilters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        const url = `${EndPoints.WAREHOUSE_QUOTES.GET_WAREHOUSE_EXTRA_HISTORY}?${queryString}`;
        doGet({
            ...events,
            url: url.replace(
                ':quote_id',
                quoteId.toString()
            ),
            setFetching: setFetchingGetWarehouseQuoteHistorys
        });
    };

    const showWarehouseQuoteHistory = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.SHOW_WAREHOUSE_STORAGE.replace(':id', id.toString()),
            setFetching: setFetchingShowWarehouseQuoteHistory
        });
    };

    const editWarehouseHistory = (
        quoteId: number,
        events: ServiceEvents = {}
    ) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.EDIT_WAREHOUSE_STORAGE.replace(':id', quoteId.toString()),
            setFetching: setFetchingEditWarehouseQuoteHistory
        
        
        });
    };


    const createWarehouseQuoteHistory = (
        quoteId: number,
        events: ServiceEvents = {}
    ) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.CREATE_WAREHOUSE_STORAGE.replace(':quote_id', quoteId.toString()),
            setFetching: setFetchingCreateWarehouseQuoteHistory
        });
    };

    const storeWarehouseQuoteHistory = (
        data: WarehouseQuoteHistoryDataForm,
        events: ServiceEvents = {}
    ) => {
        doPost({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.STORE_WAREHOUSE_STORAGE,
            body: data,
            setFetching: setFetchingStoreWarehouseQuoteHistory
        });
    };

    const updateWarehouseHistory = (
        id: number,
        data: WarehouseQuoteHistoryDataForm,
        events: ServiceEvents = {}
    ) => {
        doPut({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.UPDATE_WAREHOUSE_STORAGE.replace(':id', id.toString()),
            body: data,
            setFetching: setFetchingUpdateWarehouseHistory
        });
    };

    const deleteWarehouseQuoteHistory = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.DELETE_WAREHOUSE_STORAGE.replace(':id', id.toString())
        });
    };




    return {
        getWarehouseQuoteHistory,
        getAllWarehouseQuoteHistorysByQuote,
        showWarehouseQuoteHistory,
        storeWarehouseQuoteHistory,
        updateWarehouseHistory,
        deleteWarehouseQuoteHistory,
        editWarehouseHistory,
        createWarehouseQuoteHistory,
        fetchingCreateWarehouseQuoteHistory,
        fetchingGetWarehouseQuoteHistory,
        fetchingGetWarehouseQuoteHistorys,
        fetchingStoreWarehouseQuoteHistory,
        fetchingUpdateWarehouseHistory,
        fetchingEditWarehouseQuoteHistory,
        fetchingShowWarehouseQuoteHistory
    };
};

export default useWarehouseHistoryService;
